(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll2-application"] && !Shopify.designMode) return;
  try {
    



if (!customElements.get('ll2-registration')) customElements.define('ll2-registration', class extends HTMLElement {

 connectedCallback() {

  const channel = this.querySelector('[data-sales-channel]'); const type = this.querySelector('[data-business-type]'); const field = this.querySelector('[data-platform-field]'); if (!channel || !type || !field) return;

  const input = field.querySelector('input'); const marker = field.querySelector('[data-platform-required]');

  const update = () => { const online = type.value === 'online' || ['online','both'].includes(channel.value); field.hidden = !online; input.disabled = !online; input.required = online; marker.textContent = online ? '*' : ''; };

  channel.addEventListener('change', update); type.addEventListener('change', update); update();

 }

});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll2-collection-grid"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ll2-collection-browser')) customElements.define('ll2-collection-browser',class extends HTMLElement {

  connectedCallback(){

    if(this.started)return;this.started=true;

    this.groups=Array.from(this.querySelectorAll('[data-filter-group]'));

    if(!this.groups.length)return;

    this.labels=JSON.parse(this.querySelector('[data-filter-labels]').textContent);

    this.grid=this.querySelector('[data-filter-grid]');

    this.loadStatus=this.querySelector('[data-filter-load-status]');

    this.retry=this.querySelector('[data-filter-retry]');

    this.clear=this.querySelector('[data-filter-clear]');

    this.events=new AbortController();

    this.addEventListener('change',e=>{if(e.target.matches('[data-filter-input]'))this.apply(true);},{signal:this.events.signal});

    this.clear.addEventListener('click',()=>{this.querySelectorAll('[data-filter-input]').forEach(input=>input.checked=false);this.apply(true);},{signal:this.events.signal});

    this.retry.addEventListener('click',()=>this.prepare(),{signal:this.events.signal});

    this.prepare();

  }

  disconnectedCallback(){this.events?.abort();this.request?.abort();this.started=false;}

  normalize(value){return String(value).trim().toLowerCase();}

  values(card,group){

    if(group.dataset.source==='tag')return card.filterTags;

    return (card.filterOptions.find(option=>this.normalize(option.name)===this.normalize(group.dataset.optionName))?.values||[]).map(value=>this.normalize(value.name));

  }

  matches(card,group,selected){return !selected.length || selected.some(value=>this.values(card,group).includes(this.normalize(value)));}

  async prepare(){

    this.request?.abort();this.request=new AbortController();

    this.retry.hidden=true;this.loadStatus.hidden=false;this.loadStatus.textContent=this.labels.loading;

    this.querySelector('.ll2-catalog-results').setAttribute('aria-busy','true');

    try{

      let nodes=Array.from(this.grid.querySelectorAll('[data-filter-card]'));

      let next=this.querySelector('[data-filter-next]')?.href;

      if(Number(this.grid.dataset.currentPage)>1){const first=new URL(location.href);first.searchParams.delete('page');next=first.href;nodes=[];}

      const visited=new Set();

      while(next){

        const url=new URL(next,location.origin);

        if(url.origin!==location.origin || visited.has(url.href))throw new Error('Invalid collection page');

        visited.add(url.href);url.searchParams.set('section_id',this.dataset.sectionId);

        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);

        const response=await fetch(url,{credentials:'same-origin',signal:this.request.signal,cache:'no-store'});

        if(!response.ok)throw new Error('Collection unavailable');

        const html=new DOMParser().parseFromString(await response.text(),'text/html');

        const result=html.querySelector('ll2-collection-browser');

        if(!result)throw new Error('Collection unavailable');

        nodes.push(...result.querySelectorAll('[data-filter-card]'));

        next=result.querySelector('[data-filter-next]')?.getAttribute('href');

      }

      if(this.request.signal.aborted)return;

      const unique=new Map(nodes.map(node=>[node.dataset.productId,node]));

      this.cards=[...unique.values()];

      this.cards.forEach(card=>{card.filterTags=JSON.parse(card.dataset.productTags).map(value=>this.normalize(value));card.filterOptions=JSON.parse(card.dataset.productOptions);});

      this.grid.replaceChildren(...this.cards);

      this.querySelector('[data-filter-pagination]').hidden=true;

      this.buildGroups();this.loadStatus.hidden=true;this.apply(false);

    }catch(error){if(error.name!=='AbortError'){this.loadStatus.textContent=this.labels.error;this.retry.hidden=false;}}

    finally{this.querySelector('.ll2-catalog-results').removeAttribute('aria-busy');}

  }

  buildGroups(){

    const params=new URL(location.href).searchParams;

    for(const group of this.groups){

      const config=JSON.parse(group.querySelector('[data-filter-config]').textContent)||'';

      let values=config.split(/\r?\n/).map(line=>line.trim()).filter(Boolean).map(line=>{const parts=line.split('|');return{label:parts[0].trim(),value:(parts[1]||parts[0]).trim()};});

      if(!values.length){

        const found=new Map();

        this.cards.forEach(card=>{

          if(group.dataset.source==='tag')JSON.parse(card.dataset.productTags).forEach(value=>found.set(this.normalize(value),value));

          else (card.filterOptions.find(option=>this.normalize(option.name)===this.normalize(group.dataset.optionName))?.values||[]).forEach(value=>found.set(this.normalize(value.name),value.name));

        });

        values=[...found.values()].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})).map(value=>({label:value,value}));

      }

      const container=group.querySelector('[data-filter-values]');container.replaceChildren();

      const selected=params.getAll('ll2f.'+group.dataset.filterKey);

      for(const [index,value] of values.entries()){

        const label=document.createElement('label');label.className='ll2-filter-choice';

        const input=document.createElement('input');input.type='checkbox';input.dataset.filterInput='';input.value=value.value;input.id=this.dataset.sectionId+'-'+group.dataset.filterKey+'-'+index;input.checked=selected.includes(value.value);

        const text=document.createElement('span');text.textContent=value.label;

        const count=document.createElement('small');count.dataset.filterValueCount='';

        label.append(input,text,count);container.append(label);

      }

      group.hidden=!values.length;

    }

  }

  apply(updateUrl){

    const selected=new Map(this.groups.map(group=>[group,Array.from(group.querySelectorAll('[data-filter-input]:checked')).map(input=>input.value)]));

    let count=0;

    for(const card of this.cards){

      const visible=this.groups.every(group=>this.matches(card,group,selected.get(group)));

      card.hidden=!visible;if(visible)count++;

      this.updateProductLinks(card,selected);

    }

    for(const group of this.groups){

      group.querySelectorAll('[data-filter-input]').forEach(input=>{

        const count=this.cards.filter(card=>this.matches(card,group,[input.value])&&this.groups.every(other=>other===group||this.matches(card,other,selected.get(other)))).length;

        input.disabled=count===0&&!input.checked;

        input.closest('label').querySelector('[data-filter-value-count]').textContent=count;

      });

    }

    this.querySelector('[data-filter-count]').textContent=count===1?this.labels.one:this.labels.count.replace('__COUNT__',count);

    this.querySelector('[data-filter-empty]').hidden=count>0||this.cards.length===0;

    this.clear.hidden=![...selected.values()].some(values=>values.length);

    const url=new URL(location.href);const inputs=this.querySelector('[data-filter-query-inputs]');inputs.replaceChildren();

    for(const group of this.groups){

      const key='ll2f.'+group.dataset.filterKey;url.searchParams.delete(key);

      for(const value of selected.get(group)){

        url.searchParams.append(key,value);

        const input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;inputs.append(input);

      }

    }

    if(updateUrl){url.searchParams.delete('page');history.replaceState(history.state,'',url);}

  }

  updateProductLinks(card,selected){

    const relevant=this.groups.filter(group=>group.dataset.source==='option'&&selected.get(group).length);

    const url=new URL(card.dataset.productUrl,location.origin);

    if(relevant.length){

      const ids=card.filterOptions.map(option=>{

        const group=relevant.find(group=>this.normalize(group.dataset.optionName)===this.normalize(option.name));

        const choice=group?option.values.find(value=>selected.get(group).some(selectedValue=>this.normalize(selectedValue)===this.normalize(value.name))):option.values[0];

        return choice?.id;

      });

      if(ids.length&&ids.every(Boolean))url.searchParams.set('option_values',ids.join(','));

    }

    card.querySelectorAll('[data-ll2-product]').forEach(link=>link.href=url.pathname+url.search);

  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll2-experience"]) return;
  try {
    

if (!customElements.get('ll2-experience')) customElements.define('ll2-experience', class extends HTMLElement {

  connectedCallback() {

    if (this.ready) return;

    this.ready = true;

    this.labels = JSON.parse(this.querySelector('[data-ll2-labels]').textContent);

    this.dialog = this.querySelector('dialog');

    this.body = this.querySelector('[data-ll2-body]');

    this.titleElement = this.querySelector('#ll2-popup-title');

    this.backButton = this.querySelector('[data-ll2-back]');

    this.events = new AbortController();

    const eventOptions = {signal:this.events.signal};

    document.addEventListener('click', e => this.handleClick(e), eventOptions);

    this.body.addEventListener('change', e => this.handleChange(e), eventOptions);

    this.body.addEventListener('submit', e => this.handlePurchase(e), eventOptions);

    this.body.addEventListener('input', e => { if(e.target.matches('[data-ll2-search]')) this.filter(); }, eventOptions);

    this.dialog.addEventListener('click', e => { if(e.target === this.dialog) this.dialog.close(); }, eventOptions);

    this.dialog.addEventListener('close', () => this.afterClose(), eventOptions);

    window.addEventListener('focus', () => this.checkSession(), eventOptions);

    window.addEventListener('pageshow', () => this.checkSession(), eventOptions);

    document.addEventListener('visibilitychange', () => { if(!document.hidden) this.checkSession(); }, eventOptions);

  }

  disconnectedCallback() {

    this.events?.abort(); this.request?.abort(); clearInterval(this.sessionTimer);

    if(this.dialog?.open) this.dialog.close();

    if(this.previousOverflow !== undefined) document.documentElement.style.overflow=this.previousOverflow;

    this.ready=false;

  }

  handleClick(e) {

    if(e.composedPath().some(el=>el.localName==='shopify-account')) {this.watchSession();return;}

    if(e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const button=e.target.closest('[data-ll2-close],[data-ll2-back],[data-ll2-reset]');

    if(button) {

      e.preventDefault();

      if(button.hasAttribute('data-ll2-close')) this.dialog.close();

      else if(button.hasAttribute('data-ll2-back')) this.restoreCollection();

      else {this.body.querySelectorAll('[data-ll2-filter]').forEach(s=>s.value='');this.body.querySelector('[data-ll2-search]').value='';this.filter();}

      return;

    }

    const link=e.target.closest('a[data-ll2-collection],a[data-ll2-product],a[data-ll2-account],a[data-ll2-page],a[data-ll2-account-page]');

    if(!link || link.target==='_blank') return;

    e.preventDefault();

    if(!this.dialog.open) {this.opener=link;this.savedCollection=null;}

    if(link.hasAttribute('data-ll2-account') || link.hasAttribute('data-ll2-account-page')) {

      this.savedCollection=null;

      this.load(link.hasAttribute('data-ll2-account-page')?link.href:this.dataset.root,'ll2-account-content');

    } else if(link.hasAttribute('data-ll2-product')) {

      if(this.view==='collection' && this.dialog.open) this.savedCollection={node:this.body.firstElementChild,title:this.titleElement.textContent,scroll:this.body.scrollTop,url:this.currentUrl};

      this.load(link.href,'ll2-popup-product');

    } else {this.savedCollection=null;this.load(link.href,'ll2-popup-collection');}

  }

  async handleChange(e) {

    if(e.target.matches('[data-ll2-filter]')) {this.filter();return;}

    if(!e.target.matches('[data-ll2-option]')) return;

    const current=this.body.querySelector('[data-product-url]');

    const selectors=Array.from(this.body.querySelectorAll('[data-ll2-option]'));

    const changed=e.target.selectedOptions[0];

    const url=new URL(changed.dataset.productUrl || current.dataset.productUrl,location.origin);

    url.searchParams.set('option_values',selectors.map(s=>s.value).join(','));

    const inputs=Array.from(this.body.querySelectorAll('.ll2-popup-inquiry input:not([type=hidden])')).map(el=>[el.id,el.value]);

    const inquiryOpen=Boolean(this.body.querySelector('.ll2-popup-inquiry[open]'));

    const scroll=this.body.scrollTop;

    const focusId=e.target.id;

    const quantity=this.body.querySelector('[name="quantity"]')?.value;

    await this.load(url.href,'ll2-popup-product',false);

    if(quantity && this.body.querySelector('[name="quantity"]'))this.body.querySelector('[name="quantity"]').value=quantity;

    for(const [id,value] of inputs){const input=this.body.querySelector('#'+id);if(input)input.value=value;}

    if(inquiryOpen && this.body.querySelector('.ll2-popup-inquiry')) this.body.querySelector('.ll2-popup-inquiry').open=true;

    this.body.scrollTop=scroll;

    this.body.querySelector('#'+focusId)?.focus({preventScroll:true});

  }

  async handlePurchase(e) {

    const form=e.target;

    if(!form.matches('.ll2-popup-purchase'))return;

    e.preventDefault();e.stopPropagation();

    const variant=form.querySelector('[name="id"]');

    if(this.dataset.authenticated!=='true' || this.purchasing || !variant?.value || variant.disabled || !form.reportValidity())return;

    this.purchasing=true;

    const checkout=e.submitter?.dataset.ll2Purchase==='checkout';

    const checkoutForm=this.body.querySelector('[data-ll2-checkout]');

    const data=new FormData(form);

    const status=form.querySelector('[data-ll2-purchase-status]');

    const controls=Array.from(this.body.querySelectorAll('[data-ll2-option],.ll2-popup-purchase button,.ll2-popup-purchase input:not([type=hidden])')).filter(el=>!el.disabled);

    controls.forEach(el=>el.disabled=true);form.setAttribute('aria-busy','true');

    status.textContent=this.labels.adding;

    try {

      const url=new URL(form.action);url.pathname=url.pathname.replace(/\/add\/?$/,'/add.js');

      const response=await fetch(url,{method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});

      const result=await response.json();

      if(!response.ok){status.textContent=typeof result.description==='string'?result.description:this.labels.purchase_error;return;}

      status.textContent=this.labels.added;form.querySelector('[data-ll2-view-bag]').hidden=false;

      if(checkout){document.body.append(checkoutForm);checkoutForm.submit();return;}

      try {

        const cartResponse=await fetch(new URL('cart.js',new URL(this.dataset.root,location.origin)),{credentials:'same-origin',cache:'no-store'});

        if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-ll2-cart-count]').forEach(el=>el.textContent=cart.item_count);document.querySelectorAll('.ll2-bag-link').forEach(el=>el.setAttribute('aria-label',this.labels.cart_name.replace('__COUNT__',cart.item_count)));}

      } catch {}

    } catch {status.textContent=this.labels.purchase_error;form.querySelector('[data-ll2-view-bag]').hidden=false;}

    finally {this.purchasing=false;controls.forEach(el=>el.disabled=false);form.removeAttribute('aria-busy');}

  }

  async load(href,section,focus=true) {

    this.request?.abort();

    const controller=new AbortController();this.request=controller;

    const url=new URL(href,location.origin);

    if(url.origin!==location.origin) return;

    url.hash='';url.searchParams.set('section_id',section);

    const preview=new URL(location.href).searchParams.get('preview_theme_id');

    if(preview)url.searchParams.set('preview_theme_id',preview);

    this.currentUrl=url.href;

    this.show();

    this.body.setAttribute('aria-busy','true');

    this.backButton.hidden=!this.savedCollection;

    this.titleElement.textContent=section==='ll2-account-content'?this.labels.account:this.labels.loading;

    const status=document.createElement('p');status.className='ll2-popup-status';status.role='status';status.textContent=this.labels.loading;this.body.replaceChildren(status);

    try {

      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:controller.signal});

      if(!response.ok)throw new Error('Response unavailable');

      const html=new DOMParser().parseFromString(await response.text(),'text/html');

      const content=html.querySelector('[data-ll2-content]');

      if(!content || content.textContent.includes('Liquid error'))throw new Error('Content unavailable');

      if(controller.signal.aborted)return;

      this.body.replaceChildren(content);

      this.titleElement.textContent=content.dataset.title;

      this.view=content.dataset.view;

      if(this.view==='collection')this.buildFilters();

      this.body.scrollTop=0;

      if(focus)this.titleElement.focus({preventScroll:true});

    } catch(error) {

      if(error.name==='AbortError')return;

      const box=document.createElement('div');box.className='ll2-popup-status';box.role='alert';

      const message=document.createElement('p');message.textContent=this.labels.error;

      const retry=document.createElement('button');retry.type='button';retry.className='ll2-button';retry.textContent=this.labels.retry;

      retry.addEventListener('click',()=>this.load(href,section));box.append(message,retry);this.body.replaceChildren(box);

    } finally {if(this.request===controller)this.body.setAttribute('aria-busy','false');}

  }

  show() {

    if(this.dialog.open)return;

    this.previousOverflow=document.documentElement.style.overflow;

    document.documentElement.style.overflow='hidden';

    this.dialog.showModal();

  }

  afterClose() {

    this.request?.abort();this.savedCollection=null;this.body.replaceChildren();this.view=null;

    document.documentElement.style.overflow=this.previousOverflow||'';this.previousOverflow=undefined;

    this.opener?.focus({preventScroll:true});

  }

  restoreCollection() {

    if(!this.savedCollection)return;

    this.request?.abort();const state=this.savedCollection;

    this.body.replaceChildren(state.node);this.titleElement.textContent=state.title;this.currentUrl=state.url;this.view='collection';this.savedCollection=null;this.backButton.hidden=true;this.body.setAttribute('aria-busy','false');

    this.cards=Array.from(this.body.querySelectorAll('[data-ll2-card]'));this.body.scrollTop=state.scroll;this.titleElement.focus({preventScroll:true});

  }

  buildFilters() {

    this.cards=Array.from(this.body.querySelectorAll('[data-ll2-card]'));

    const groups=new Map();

    const normalize=name=>name.toLowerCase().replace(/[^a-z0-9]/g,'');

    this.cards.forEach(card=>{

      card.ll2Options=new Map();

      for(const option of JSON.parse(card.dataset.options)) {

        const raw=normalize(option.name);

        if(/catalog|code|title|sku/.test(raw))continue;

        const key=/purity|karat|carat|ayar/.test(raw)?'purity':/width|thickness|diameter|mm|kalinlik/.test(raw)?'width':raw;

        const values=option.values.map(String);

        card.ll2Options.set(key,values);

        if(!groups.has(key))groups.set(key,{name:this.labels[key]||option.name,values:new Set()});

        values.forEach(v=>groups.get(key).values.add(v));

      }

      const tags=JSON.parse(card.dataset.tags);

      const construction=tags.some(t=>/^hollow(?:-|$)/i.test(t))?'hollow':tags.some(t=>/^solid(?:-|$)/i.test(t))?'solid':null;

      if(construction){card.ll2Options.set('construction',[construction]);if(!groups.has('construction'))groups.set('construction',{name:this.labels.construction,values:new Set()});groups.get('construction').values.add(construction);}

    });

    const filters=this.body.querySelector('[data-ll2-filters]');

    for(const [key,group] of groups) {

      const wrap=document.createElement('div');const label=document.createElement('label');const select=document.createElement('select');

      select.id='ll2-filter-'+key;select.dataset.ll2Filter=key;label.htmlFor=select.id;label.textContent=group.name;

      select.add(new Option(this.labels.all,''));

      [...group.values].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})).forEach(value=>select.add(new Option(key==='construction'?this.labels[value]:value,value)));

      wrap.append(label,select);filters.append(wrap);

    }

    this.filter();

  }

  filter() {

    const selected=Array.from(this.body.querySelectorAll('[data-ll2-filter]')).filter(s=>s.value);

    const term=this.body.querySelector('[data-ll2-search]').value.trim().toLowerCase();let count=0;

    for(const card of this.cards){const match=card.dataset.title.toLowerCase().includes(term)&&selected.every(s=>(card.ll2Options.get(s.dataset.ll2Filter)||[]).includes(s.value));card.hidden=!match;if(match)count++;}

    this.body.querySelector('[data-ll2-count]').textContent=count===1?this.labels.one_result:this.labels.results.replace('__COUNT__',count);

    this.body.querySelector('[data-ll2-no-results]').hidden=count>0 || this.cards.length===0;

  }

  watchSession() {

    if(this.sessionTimer)return;

    let ticks=0;this.sessionTimer=setInterval(()=>{this.checkSession();if(++ticks>=48){clearInterval(this.sessionTimer);this.sessionTimer=null;}},2500);

  }

  async checkSession() {

    if(document.hidden || this.checking || Date.now()-(this.lastSessionCheck||0)<2000)return;

    this.checking=true;this.lastSessionCheck=Date.now();

    try {

      const url=new URL(this.dataset.root,location.origin);url.searchParams.set('section_id','ll2-session');

      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);

      const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)return;

      const html=new DOMParser().parseFromString(await response.text(),'text/html');const state=html.querySelector('[data-ll2-session]');

      if(state && state.dataset.ll2Session!==this.dataset.authenticated)location.reload();

    } catch {} finally {this.checking=false;}

  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll2-process"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ll2-process-tabs')) customElements.define('ll2-process-tabs', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return; this.ready = true;
  const buttons = [...this.querySelectorAll('[role="tab"]')];
  const select = (button) => { buttons.forEach(item => { const active = item === button; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; this.querySelector('#' + CSS.escape(item.getAttribute('aria-controls'))).hidden = !active; }); };
  buttons.forEach((button, index) => { button.addEventListener('click', () => select(button)); button.addEventListener('keydown', event => { if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); const next = event.key === 'Home' ? buttons[0] : event.key === 'End' ? buttons[buttons.length - 1] : buttons[(index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length]; select(next); next.focus(); }); });
  document.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[role="tabpanel"]'); if (panel && this.contains(panel)) select(buttons.find(button => button.getAttribute('aria-controls') === panel.id)); });
 }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
